export * as i18n from './index';
